const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_7662fa13-a20c-42f4-8e5d-f8666613b6c9/artifacts/g4o2m9hi_Sacaru.png";

const Footer = () => {
  const year = new Date().getFullYear();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-black text-white border-t border-white/10"
    >
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={LOGO_URL}
                alt="Sacaru Distribuidora"
                className="h-[72px] w-auto"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-sm font-light">
              Tu organización de confianza para realizar tus compras y
              operaciones generales de comercio.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-[#F3901A] mb-5 font-semibold">
              Navegación
            </div>
            <ul className="space-y-3">
              {[
                ["nosotros", "Nosotros"],
                ["servicios", "Servicios"],
                ["metodologia", "Método AI"],
                ["contacto", "Contacto"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button
                    onClick={() => scrollTo(id)}
                    data-testid={`footer-nav-${id}`}
                    className="text-white/70 hover:text-white text-sm link-underline"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-[#F3901A] mb-5 font-semibold">
              Contacto
            </div>
            <ul className="space-y-3 text-sm text-white/70">
              <li>
                Calle Esteban Alatorre 1288A, int. 4,
                <br />
                San Juan Bosco C.P. 44730, Guadalajara, Jalisco, México.
              </li>
              <li>
                <a
                  href="tel:+523339486615"
                  className="hover:text-white link-underline"
                >
                  33 3 948 6615
                </a>
              </li>
              <li>
                <a
                  href="mailto:contacto@sacaru-distribuidora.com"
                  className="hover:text-white link-underline"
                >
                  contacto@sacaru-distribuidora.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            © {year} Sacaru Distribuidora. Todos los derechos reservados.
          </p>
          <p className="text-white/40 text-xs uppercase tracking-[0.25em]">
            Guadalajara · Jalisco · México
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
